module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.forget_password_send_success")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "customer-forgot-success "
  }, [_c('div', [_c('div', [_vm._v("\n                " + _vm._s(_vm.$t("message.we_send_message_to_your_email")) + "\n                \n                " + _vm._s(_vm.$t("message.follow_the_instructions_provided")) + "\n                \n            ")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("message.donot_receive_email")) + "\n                    "), _c('router-link', {
    attrs: {
      "to": "/customer/account/forgotpassword"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.click_here_to_retry")) + "\n                    ")])], 1), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("message.check_your_bulk_junk_email_folder")) + "\n                    \n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t("message.confirm_your_identity_to_reset")) + " ,\n                    " + _vm._s(_vm.$t("message.click")) + "\n                     \n                    "), _c('router-link', {
    attrs: {
      "to": "/customer/contacts"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("message.support_center")) + " \n                    ")]), _vm._v("\n                    " + _vm._s(_vm.$t("message.for_help")) + "\n                ")], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc62f8b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/account/Forgotpasswordsubmit.vue
// module id = 265
// module chunks = 1